export default __webpack_public_path__ + "static/media/indicator-light.d186f5ff.svg";